import _defineProperty from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';

/**
 * 查询我的报销
 * 接口文档http://43.136.181.215:4999/web/#/48/3143
 */
export function queryReimburse(_x, _x2, _x3) {
  return _queryReimburse.apply(this, arguments);
}
/**
 * 查询报销分类
 * 接口文档http://43.136.181.215:4999/web/#/48/3144
 */
function _queryReimburse() {
  _queryReimburse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page, limit, param) {
    var data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            reimburseStatus: param.reimburseStatus,
            cateId: param.cateId,
            startDate: param.startDate,
            endDate: param.endDate,
            query: param.query
          };
          return _context.a(2, request("/reimburse/queryReimburse", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryReimburse.apply(this, arguments);
}
export function queryCate() {
  return _queryCate.apply(this, arguments);
}
/**
 * 报销新增编辑(差旅)
 * 接口文档http://43.136.181.215:4999/web/#/48/3141
 */
function _queryCate() {
  _queryCate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request("/reimburse/queryCate", METHOD.POST));
      }
    }, _callee2);
  }));
  return _queryCate.apply(this, arguments);
}
export function saveReimburse(_x4) {
  return _saveReimburse.apply(this, arguments);
}
/**
 * 报销新增编辑(费用)
 * 接口文档http://43.136.181.215:4999/web/#/48/3142
 */
function _saveReimburse() {
  _saveReimburse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, request("/reimburse/saveReimburse", METHOD.POST, data));
      }
    }, _callee3);
  }));
  return _saveReimburse.apply(this, arguments);
}
export function saveReimburseCost(_x5) {
  return _saveReimburseCost.apply(this, arguments);
}
/**
 * 查询差旅详情
 * 接口文档http://43.136.181.215:4999/web/#/48/3145
 */
function _saveReimburseCost() {
  _saveReimburseCost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, request("/reimburse/saveReimburseCost", METHOD.POST, data));
      }
    }, _callee4);
  }));
  return _saveReimburseCost.apply(this, arguments);
}
export function queryTravel(_x6) {
  return _queryTravel.apply(this, arguments);
}
/**
 * 查询费用详情
 * 接口文档http://43.136.181.215:4999/web/#/48/3146
 */
function _queryTravel() {
  _queryTravel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, request("/reimburse/queryTravel", METHOD.POST, {
            id: id
          }));
      }
    }, _callee5);
  }));
  return _queryTravel.apply(this, arguments);
}
export function queryCost(_x7) {
  return _queryCost.apply(this, arguments);
}
/**
 * 提交报销
 * 接口文档http://43.136.181.215:4999/web/#/48/3156
 */
function _queryCost() {
  _queryCost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(id) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, request("/reimburse/queryCost", METHOD.POST, {
            id: id
          }));
      }
    }, _callee6);
  }));
  return _queryCost.apply(this, arguments);
}
export function submitReimburse(_x8) {
  return _submitReimburse.apply(this, arguments);
}
/**
 * 撤回报销
 * 接口文档http://43.136.181.215:4999/web/#/48/3171
 */
function _submitReimburse() {
  _submitReimburse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(id) {
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          return _context7.a(2, request("/reimburse/submitReimburse", METHOD.POST, {
            id: id
          }));
      }
    }, _callee7);
  }));
  return _submitReimburse.apply(this, arguments);
}
export function withdrawReimburse(_x9) {
  return _withdrawReimburse.apply(this, arguments);
}
/**
 * 删除报销
 * 接口文档http://43.136.181.215:4999/web/#/48/3172
 */
function _withdrawReimburse() {
  _withdrawReimburse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(id) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, request("/reimburse/withdrawReimburse", METHOD.POST, {
            id: id
          }));
      }
    }, _callee8);
  }));
  return _withdrawReimburse.apply(this, arguments);
}
export function delReimburse(_x0) {
  return _delReimburse.apply(this, arguments);
}
/**
 * 查询审核数据
 * 接口文档http://43.136.181.215:4999/web/#/48/3159
 */
function _delReimburse() {
  _delReimburse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(id) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, request("/reimburse/delReimburse", METHOD.POST, {
            id: id
          }));
      }
    }, _callee9);
  }));
  return _delReimburse.apply(this, arguments);
}
export function queryExamine(_x1, _x10, _x11) {
  return _queryExamine.apply(this, arguments);
}
/**
 * 审核
 * 接口文档http://43.136.181.215:4999/web/#/48/3198
 */
function _queryExamine() {
  _queryExamine = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(page, limit, param) {
    var data;
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          // 数据处理
          data = _defineProperty({
            currentNo: page,
            pageSize: limit,
            auditStatus: param.auditStatus,
            cateId: param.cateId,
            startDate: param.startDate,
            endDate: param.endDate,
            query: param.query
          }, "auditStatus", param.auditStatus);
          return _context0.a(2, request("/reimburse/queryExamine", METHOD.POST, data));
      }
    }, _callee0);
  }));
  return _queryExamine.apply(this, arguments);
}
export function reimburseExamine(_x12) {
  return _reimburseExamine.apply(this, arguments);
}
/**
 * 查询审核记录
 * 接口文档http://43.136.181.215:4999/web/#/48/3199
 */
function _reimburseExamine() {
  _reimburseExamine = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(data) {
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          return _context1.a(2, request("/reimburse/reimburseExamine", METHOD.POST, data));
      }
    }, _callee1);
  }));
  return _reimburseExamine.apply(this, arguments);
}
export function queryAuditRecord(_x13) {
  return _queryAuditRecord.apply(this, arguments);
}
/**
 * 查询审核记录(驳回)
 * 接口文档http://43.136.181.215:4999/web/#/48/3200
 */
function _queryAuditRecord() {
  _queryAuditRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(id) {
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          return _context10.a(2, request("/reimburse/queryAuditRecord", METHOD.POST, {
            id: id
          }));
      }
    }, _callee10);
  }));
  return _queryAuditRecord.apply(this, arguments);
}
export function queryAdoptRecord(_x14) {
  return _queryAdoptRecord.apply(this, arguments);
}
/**
 * 会计工作台
 * 接口文档http://43.136.181.215:4999/web/#/48/3214
 */
function _queryAdoptRecord() {
  _queryAdoptRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(id) {
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          return _context11.a(2, request("/reimburse/queryAdoptRecord", METHOD.POST, {
            id: id
          }));
      }
    }, _callee11);
  }));
  return _queryAdoptRecord.apply(this, arguments);
}
export function queryWorkbench(_x15, _x16, _x17) {
  return _queryWorkbench.apply(this, arguments);
}
/**
 * 报销打印
 * 接口文档http://43.136.181.215:4999/web/#/48/3254
 */
function _queryWorkbench() {
  _queryWorkbench = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(page, limit, param) {
    var data;
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            cateId: param.cateId,
            startDate: param.startDate,
            endDate: param.endDate,
            query: param.query
          };
          return _context12.a(2, request("/reimburse/queryWorkbench", METHOD.POST, data));
      }
    }, _callee12);
  }));
  return _queryWorkbench.apply(this, arguments);
}
export function reimbursePrint(_x18) {
  return _reimbursePrint.apply(this, arguments);
}
function _reimbursePrint() {
  _reimbursePrint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(id) {
    return _regenerator().w(function (_context13) {
      while (1) switch (_context13.n) {
        case 0:
          return _context13.a(2, request("/reimburse/reimbursePrint", METHOD.POST, {
            id: id
          }));
      }
    }, _callee13);
  }));
  return _reimbursePrint.apply(this, arguments);
}